import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowRight, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/common/Logo";
import { COUPLES } from "@/lib/media";

export default function Login() {
  const { login, apiErr } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email.trim(), password);
      toast.success("Welcome back");
      navigate(u.role === "super_admin" ? "/superadmin" : "/app");
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-cream">
      <div className="relative hidden lg:block">
        <img src={COUPLES[1]} alt="" className="absolute inset-0 w-full h-full object-cover ken-burns" />
        <div className="absolute inset-0 bg-gradient-to-t from-maroon-dark/80 via-maroon-dark/25 to-transparent" />
        <div className="absolute bottom-12 left-12 right-12">
          <h2 className="font-serif text-5xl text-cream font-light leading-tight">Every Moment.<br /><span className="text-gradient-gold italic">Found.</span></h2>
          <p className="text-cream/85 mt-4 max-w-sm">Sign in to manage your events, galleries and client selections.</p>
        </div>
      </div>

      <div className="flex items-center justify-center p-6 sm:p-12 mandala">
        <div className="w-full max-w-md">
          <Logo light />
          <h1 className="font-serif text-5xl text-ink font-light mt-10">Welcome back</h1>
          <p className="text-ink/60 mt-2">Sign in to your PMR Events studio.</p>

          <form onSubmit={submit} className="mt-8 space-y-4" data-testid="login-form">
            <div>
              <label className="text-sm text-ink/70">Email</label>
              <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="mt-1.5 w-full bg-white border border-maroon/15 rounded-xl px-4 py-3 text-ink outline-none focus:border-gold focus:ring-2 focus:ring-gold/30 transition-colors" placeholder="you@studio.com" />
            </div>
            <div>
              <label className="text-sm text-ink/70">Password</label>
              <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                className="mt-1.5 w-full bg-white border border-maroon/15 rounded-xl px-4 py-3 text-ink outline-none focus:border-gold focus:ring-2 focus:ring-gold/30 transition-colors" placeholder="••••••••" />
            </div>
            <button data-testid="login-submit" disabled={loading}
              className="w-full flex items-center justify-center gap-2 bg-maroon text-cream font-medium rounded-xl py-3.5 hover:bg-maroon-dark transition-colors disabled:opacity-60 maroon-glow">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <>Sign in <ArrowRight className="w-4 h-4" /></>}
            </button>
          </form>

          <p className="text-sm text-ink/60 mt-6">
            New to PMR Events? <Link to="/register" className="text-maroon font-medium hover:underline">Create an account</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
